import { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CompanySearch from "../../components/contract/CompanySearch";
import { createSubContract } from "../../api/contract/sub";
import MobileAttachmentBox from "../../components/common/papers/MobileAttachmentBox";

const Sub_new = () => {
  const [form, setForm] = useState({
    contract_code: "",
    title: "",
    confirmer_company_name: "",
    amount: "",
    status: "DRAFT",
    // construction_type_detail: "GENERAL",
    memo: "",
    activities: [],
    manualCompanyInput: false,
    construction_type: "본공사"
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const attachmentRef = useRef(null);

  const { id: projectId } = useParams();
  const navigate = useNavigate();
  // const form.construction_type = location.state?.construction_type || "본공사";

  const handleAmountChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, "");
    setForm({ ...form, amount: rawValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    try {
      setSaving(true);

      const formData = new FormData();
      formData.append("project", projectId);
      formData.append("contract_code", form.contract_code);
      formData.append("title", form.title);
      formData.append("confirmer_company_name", form.confirmer_company_name);
      formData.append("amount", form.amount);
      formData.append("status", form.status);
      formData.append("construction_type", form.construction_type);
      formData.append("construction_type_detail", form.construction_type_detail);
      formData.append("memo", form.memo);

      form.activities.forEach((act) => formData.append("activity_ids", act.id));

      const res = await createSubContract(formData);
      const dnsId = typeof res.dns === "object" ? res.dns.id : res.dns;
      await attachmentRef.current?.save(dnsId);

      alert("하도급 계약이 등록되었습니다");
      navigate(`../sub`);
    } catch (err) {
      console.error("등록 실패:", err);
      alert("등록 실패 다시 시도해주세요");
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, checked } = e.target;

    if (name === "manualCompanyInput") {
      setForm((prev) => ({
        ...prev,
        manualCompanyInput: checked,
        confirmer_company_name: checked ? "" : prev.confirmer_company_name,
      }));
      return;
    }

    setForm({ ...form, [name]: value });
  };

  return (
    <div className="mobile-page-root mb-16">
      <div className="mobile-page-root-inner space-y-3">
        <div className="w-full bg-white rounded-xl shadow p-4 sm:p-6">
        <h2 className="text-lg sm:text-xl font-bold mb-4">하도급 계약 등록</h2>

        <div className="flex flex-col sm:flex-row justify-end gap-2 mb-4">
          <button
            type="submit"
            form="contract-form"
            disabled={saving}
            className="btn-create w-full sm:w-auto text-sm sm:text-base disabled:opacity-60"
          >
            {saving ? "등록 중..." : "등록"}
          </button>
        </div>

        <form id="contract-form" onSubmit={handleSubmit} className="space-y-6 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
          <div className="border rounded-lg min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
            <div className="p-4 space-y-4 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
              {/* 계약 코드 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  계약 코드
                </label>
                <input
                  type="text"
                  name="contract_code"
                  value={form.contract_code}
                  onChange={handleChange}
                  className="w-full border rounded-md px-2 py-1 text-sm"
                  placeholder="계약 코드를 입력하세요"
                />
              </div>

              {/* 계약명 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  계약명
                </label>
                <input
                  type="text"
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                  className="w-full border rounded-md px-2 py-1 text-sm"
                  placeholder="계약명을 입력하세요"
                />
              </div>

              {/* 금액 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  계약 금액
                </label>
                <input
                  type="text"
                  name="amount"
                  value={form.amount}
                  onChange={handleAmountChange}
                  className="w-full border rounded-md px-2 py-1 text-sm"
                  placeholder="숫자만 입력"
                />
              </div>

              {/* 상태 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  상태
                </label>
                <select
                  name="status"
                  value={form.status}
                  onChange={handleChange}
                  className="w-full border rounded-md px-2 py-1 text-sm"
                >
                  <option value="DRAFT">임시</option>
                  <option value="FOR_INFORMATION">정보</option>
                  <option value="FOR_REVIEW">검토</option>
                  <option value="FOR_APPROVAL">승인</option>
                  <option value="FINAL">최종</option>
                  <option value="AS_BUILT">준공</option>
                  <option value="NO_LONGER_IN_USE">폐기</option>
                </select>
              </div>

              {/* 주계약업체 */}
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <label className="text-xs font-medium text-gray-600">
                    주계약업체
                  </label>
                  <div className="flex items-center gap-1 text-xs">
                    <input
                      id="manual-company"
                      type="checkbox"
                      name="manualCompanyInput"
                      checked={form.manualCompanyInput}
                      onChange={handleChange}
                      className="w-3 h-3"
                    />
                    <label
                      htmlFor="manual-company"
                      className="text-[11px] text-gray-700"
                    >
                      직접입력
                    </label>
                  </div>
                </div>

                {form.manualCompanyInput ? (
                  <input
                    type="text"
                    name="confirmer_company_name"
                    value={form.confirmer_company_name}
                    onChange={handleChange}
                    placeholder="업체명을 직접 입력하세요"
                    className="w-full border rounded-md px-2 py-1 text-sm"
                  />
                ) : (
                  <div className="flex gap-2 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                    <input
                      type="text"
                      readOnly
                      value={form.confirmer_company_name}
                      placeholder="선택된 업체 없음"
                      className="flex-1 min-w-0 border rounded-md px-2 py-1 bg-gray-100 text-sm"
                      style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                    />
                    <button
                      type="button"
                      onClick={() => setModalOpen(true)}
                      className="btn-search-sm whitespace-nowrap flex-shrink-0"
                    >
                      검색
                    </button>
                  </div>
                )}

                <CompanySearch
                  open={modalOpen}
                  onClose={() => setModalOpen(false)}
                  onSelect={(company) =>
                    setForm({
                      ...form,
                      confirmer_company_name: company.name,
                      manualCompanyInput: false,
                    })
                  }
                />
              </div>

              {/* 공종 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  공종
                </label>
                <input
                  type="text"
                  name="construction_type"
                  value={form.construction_type}
                  onChange={handleChange}
                  className="w-full border rounded-md px-2 py-1 text-sm"
                />
              </div>

              {/* 세부 공종 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  세부 공종
                </label>
                <select
                  name="construction_type_detail"
                  value={form.construction_type_detail}
                  onChange={handleChange}
                  className="w-full border rounded-md px-2 py-1 text-sm"
                >
                  <option value="GENERAL">일반</option>
                  <option value="ARCHITECTURAL">건축</option>
                  <option value="STRUCTURAL">구조</option>
                  <option value="CIVIL">토목</option>
                  <option value="LANDSCAPING">조경</option>
                  <option value="MECHANICAL">기계</option>
                  <option value="ELECTRICAL">전기</option>
                  <option value="COMMUNICATION">통신</option>
                  <option value="FIREFIGHTING">소방</option>
                  <option value="FIREFIGHTING_MECHANICAL">소방 기계</option>
                  <option value="FIREFIGHTING_ELECTRICAL">소방 전기</option>
                  <option value="INTERIOR">인테리어</option>
                  <option value="OTHERS">기타</option>
                </select>
              </div>

              {/* 특이사항 */}
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-600">
                  특이사항
                </label>
                <textarea
                  name="memo"
                  value={form.memo}
                  onChange={handleChange}
                  className="w-full h-32 border rounded-md px-2 py-2 text-sm resize-none"
                />
              </div>
            </div>
          </div>

          {/* 파일 업로드 */}
          <div className="mb-4">
            <label className="block text-sm mb-1">첨부파일 (선택)</label>
            <MobileAttachmentBox ref={attachmentRef} />
          </div>
        </form>
        </div>
      </div>
    </div>
  );
};

export default Sub_new;
